// extracted by mini-css-extract-plugin
export default {"layout":"layout___Oh2yi","header":"header___FOII9","message":"message___LqnEV","from":"from___B2P3W","button":"button___reqbT","subtext":"subtext___oknLM"};